<template>
  <v-dialog
    v-model="dialogSplitPackage"
    fullscreen
    hide-overlay
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card v-if="currentItem">
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>close</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title
          >Tách kiện #{{ currentItem.TransactionCode }}</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg5 md5 sm5 v-if="!readOnly">
            <v-layout row wrap pa-3 pt-12>
              <v-flex lg12 md12 sm12 pa-0>
                <v-text-field
                  type="number"
                  ref="number_of_pack"
                  v-model="splitItem.NumberOfPack"
                  step="1"
                  label="Số kiện tương tự"
                  class="input-group--focused"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="splitItem.Weight"
                  :decimal="2"
                  label="Câng nặng"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex> -->
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="splitItem.Length"
                  :decimal="1"
                  label="Chiều dài (cm)"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="splitItem.Width"
                  :decimal="1"
                  label="Chiều rộng (cm)"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="splitItem.Height"
                  :decimal="1"
                  label="Chiều cao (cm)"
                  class="input-group--focused"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 offset-md-10 pa-0>
                <v-btn @click="onSplitPackage">Nhập</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex :lg7="!readOnly" :md7="!readOnly" :sm7="!readOnly" :lg12="readOnly" :md12="readOnly" :sm12="readOnly">
            <v-layout pl-4 pr-2 pt-12>
              <v-flex lg12 md12 sm12>
                <v-data-table
                  :must-sort="false"
                  :headers="sub_headers"
                  :items="currentPackages"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td class="text-end" v-if="readOnly">{{ item.NumberOfPack | currency }}</td>
                      <td class="text-end" v-else>
                        <v-edit-dialog
                          :return-value.sync="item.NumberOfPack"
                          large
                          lazy
                          persistent
                          @save="onSplitPackage(false)"
                        >
                          <div>{{ item.NumberOfPack | currency }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.NumberOfPack"
                              :decimal="0"
                              label="Số kiện tương tự"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end" v-if="readOnly">{{ item.Weight | currency("", 2) }}</td>
                      <td class="text-end" v-else>
                        <v-edit-dialog
                          :return-value.sync="item.Weight"
                          large
                          lazy
                          persistent
                          @save="onSplitPackage(false)"
                        >
                          <div>{{ item.Weight | currency("", 2) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Weight"
                              :decimal="2"
                              label="Cân nặng"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end" v-if="readOnly">{{ item.Length | currency("", 1) }}</td>
                      <td class="text-end" v-else>
                        <v-edit-dialog
                          :return-value.sync="item.Length"
                          large
                          lazy
                          persistent
                          @save="onSplitPackage(false)"
                        >
                          <div>{{ item.Length | currency("", 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Length"
                              :decimal="1"
                              label="Chiều dài (cm)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end" v-if="readOnly">{{ item.Width | currency("", 1) }}</td>
                      <td class="text-end" v-else>
                        <v-edit-dialog
                          :return-value.sync="item.Width"
                          large
                          lazy
                          persistent
                          @save="onSplitPackage(false)"
                        >
                          <div>{{ item.Width | currency("", 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Width"
                              :decimal="1"
                              label="Chiều rộng (cm)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end" v-if="readOnly">{{ item.Height | currency("", 1) }}</td>
                      <td class="text-end" v-else>
                        <v-edit-dialog
                          :return-value.sync="item.Height"
                          large
                          lazy
                          persistent
                          @save="onSplitPackage(false)"
                        >
                          <div>{{ item.Height | currency("", 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Height"
                              :decimal="1"
                              label="Chiều cao (cm)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                     <td class="text-end">
                        {{ item.TotalWeight | currency("", 2) }}
                      </td>
                      <td class="text-end">
                        {{ item.TotalVolume | currency("", 3) }}
                      </td>
                      <td class="text-center">
                        <v-icon small @click="deleteSubItem(index)" v-if="!readOnly"
                          >delete</v-icon
                        >
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { sendErrorNotice } from "@/commons/utils";
export default {
  props: ["currentItem", "dialogSplitPackage", "readOnly"],
  data() {
    return {
      sub_headers: [
        {
          text: "Kiện tương tự",
          value: "NumberOfPack",
          sortable: false,
          align: "end",
        },
        {
          text: "Cân nặng",
          value: "Weight",
          sortable: false,
          align: "end",
        },
        {
          text: "Chiều dài",
          value: "Length",
          sortable: false,
          align: "end",
        },
        {
          text: "Chiều rộng",
          value: "Width",
          sortable: false,
          align: "end",
        },
        {
          text: "Chiều cao",
          value: "Height",
          sortable: false,
          align: "end",
        },
        {
          text: "Tổng cân",
          value: "TotalWeight",
          sortable: false,
          align: "end",
        },
        {
          text: "Tổng khối",
          value: "TotalVolume",
          sortable: false,
          align: "end",
        },
        {
          text: "Thao tác",
          sortable: false,
          align: "center",
        },
      ],
      splitItem: { NumberOfPack: 1 },
    };
  },
  computed: {
    currentPackages() {
      return this.currentItem && this.currentItem.Packages
        ? JSON.parse(this.currentItem.Packages)
        : [];
    },
  },
  methods: {
    closePopup() {
      this.$emit("closePopup");
    },
    async onSplitPackage(isNew = true) {
      let split_packages = [...this.currentPackages];
      if (isNew) {
        split_packages.push({
          NumberOfPack: this.splitItem.NumberOfPack,
          Weight: this.splitItem.Weight,
          Length: this.splitItem.Length,
          Width: this.splitItem.Width,
          Height: this.splitItem.Height,
          TotalWeight: this.splitItem.Weight * this.splitItem.NumberOfPack,
          TotalVolume: Math.round(this.splitItem.NumberOfPack * (this.splitItem.Length * this.splitItem.Width * this.splitItem.Height) / 10000) / 100,
        });
      }
      let total_pack = 0;
      for (let i = 0; i < split_packages.length; i++) {
        const element = split_packages[i];
        element.TotalWeight = element.Weight * element.NumberOfPack;
        element.TotalVolume = Math.round(element.NumberOfPack * (element.Length * element.Width * element.Height) / 10000) / 100;
        total_pack += Number(element.NumberOfPack);
      }
      if (total_pack == this.currentItem.NumberOfPack || await window.getApp.showConfirmation(`Số kiện tách ${total_pack}/${this.currentItem.NumberOfPack}, bạn có chắc chắn không?`)) {
        this.currentItem.Packages = JSON.stringify(split_packages);
        if (isNew) {
          this.splitItem = { NumberOfPack: 1 };
          this.$nextTick(() => this.$refs.number_of_pack.focus());
        }
        this.$store.dispatch("orderTransaction/setDetail", {
          data: {
            Packages: this.currentItem.Packages,
            TransactionView: 'transaction_list'
          },
          id: this.currentItem.ID,
        });
      }
    },
    deleteSubItem(index) {
      let split_packages = [...this.currentPackages];
      split_packages.splice(index, 1);
      this.currentItem.Packages = JSON.stringify(split_packages);
      this.$store.dispatch("orderTransaction/setDetail", {
        data: {
          Packages: this.currentItem.Packages,
          TransactionView: 'transaction_list'
        },
        id: this.currentItem.ID,
      });
    },
    created() {
        this.$nextTick(() => this.$refs.number_of_pack.focus());
    }
  },
};
</script>
